/* Display policy for the reviewed kit collections. No inventory or cart writes. */
(function () {
  'use strict';
  var marker = document.querySelector('script[data-smk-stock-collection]');
  if (!marker || !window.customElements) return;
  var key = 'filter.v.availability';
  var sequence = 0, controller = null, historyMode = 'push';
  var keep = /^(utm_|gclid$|gbraid$|wbraid$|msclkid$|lp_test$|preview_theme_id$)/;

  function params(value) {
    var p = new URLSearchParams(value || '');
    // These collection landing pages offer purchasable products only.
    p.set(key, '1');
    if (!p.get('sort_by')) p.set('sort_by', 'best-selling');
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (keep.test(k) && !p.has(k)) p.set(k, v);
    });
    return p.toString();
  }

  function notice(message, retry) {
    var grid = document.querySelector('[data-smk-stock-grid]');
    if (!grid) return;
    var el = document.getElementById('smk-stock-status');
    if (!el) {
      el = document.createElement('p'); el.id = 'smk-stock-status';
      el.setAttribute('role', 'status');
      grid.parentNode.insertBefore(el, grid);
    }
    el.textContent = message;
    if (retry) {
      var button = document.createElement('button'); button.type = 'button';
      button.className = 'btn btn-small btn-link'; button.textContent = 'Try again';
      button.addEventListener('click', retry); el.appendChild(button);
    }
  }

  function validate(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = doc.querySelector('[data-smk-stock-grid]');
    if (!grid || grid.dataset.smkAvailableActive !== 'true') throw new Error('Native availability filter did not apply');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.collection-product-clm'));
    var total = Number(grid.dataset.smkTotal), size = Number(grid.dataset.smkPageSize), page = Number(grid.dataset.smkPage);
    if (!Number.isInteger(total) || total < 0 || !Number.isInteger(size) || size < 1 || !Number.isInteger(page) || page < 1) throw new Error('Invalid pagination metadata');
    var expected = Math.min(size, Math.max(0, total - (page - 1) * size));
    if (cards.length !== expected) throw new Error('Incomplete filtered page');
    var ids = new Set();
    cards.forEach(function (card) {
      if (card.dataset.smkAvailable !== 'true' || !card.querySelector('a[href*="/products/"]')) throw new Error('Unavailable or empty product card');
      if (!card.dataset.smkProductId || ids.has(card.dataset.smkProductId)) throw new Error('Duplicate or missing product ID');
      ids.add(card.dataset.smkProductId);
    });
    if (!doc.querySelector('.collection-product-main') || !doc.querySelector('.js-product-count')) throw new Error('Missing collection result containers');
    return doc;
  }

  customElements.whenDefined('sht-coll-prd-fltr-frm').then(function () {
    var Cls = customElements.get('sht-coll-prd-fltr-frm');
    var form = document.querySelector('sht-coll-prd-fltr-frm');
    if (!Cls || !form || Cls.prototype.smkStockWrapped) return;
    if (marker.dataset.smkAvailableSupported !== 'true') {
      console.error('[stock-policy] Native Availability must be configured before release');
      return; // Leave the existing page functional; QA must block publication.
    }
    Cls.prototype.smkStockWrapped = true;
    var originalUpdate = Cls.prototype.updateURL;
    Cls.prototype.updateURL = function (query) {
      if (historyMode === 'replace') history.replaceState({searchParams: query}, '', location.pathname + '?' + query);
      else if (location.search.slice(1) !== query) originalUpdate.call(this, query);
    };
    Cls.prototype.renderPage = function (query, event, options) {
      var self = this, request = ++sequence, normalized = params(query);
      if (controller) controller.abort();
      controller = new AbortController();
      var grid = document.querySelector('[data-smk-stock-grid]');
      if (grid) grid.setAttribute('aria-busy', 'true');
      notice('Updating products…');
      var timedOut = false, timeout = setTimeout(function () { timedOut = true; if (request === sequence) controller.abort(); }, 20000);
      return fetch(self.buildURL(normalized), {signal: controller.signal}).then(function (response) {
        if (!response.ok) throw new Error('Product request failed: ' + response.status);
        return response.text();
      }).then(function (html) {
        if (request !== sequence) return;
        var validated = validate(html), metadata = validated.querySelector('[data-smk-stock-grid]').dataset;
        if (Number(metadata.smkTotal) > 0 && Number(metadata.smkPage) > Math.ceil(Number(metadata.smkTotal) / Number(metadata.smkPageSize))) {
          var firstPage = new URLSearchParams(normalized);
          if (!firstPage.has('page')) throw new Error('Unexpected server page');
          firstPage.delete('page'); return self.renderPage(firstPage.toString(), null, {replaceHistory: true});
        }
        // Commit only the newest validated response. Keep the theme's existing card renderer.
        historyMode = options && options.replaceHistory ? 'replace' : 'push';
        try {
          self.renderFilters(html, event);
          self.renderReturnedResults(self.refineReturnedResults(html), normalized);
          self.renderProductCount(html); self.renderSortByField(html);
        } finally { historyMode = 'push'; }
        if (typeof mainCollectionFilter === 'function') mainCollectionFilter();
        [self.compare, self.compareDialog, self.compareSticky].forEach(function (x) { if (x && x.init) x.init(); });
        if (typeof SHTElementLazyLoad !== 'undefined') new SHTElementLazyLoad();
        var status = document.getElementById('smk-stock-status'); if (status) status.remove();
      }).catch(function (error) {
        if (request !== sequence) return;
        if (error.name === 'AbortError' && !timedOut) return;
        console.error('[stock-policy]', error);
        notice("We couldn't refresh the products. Previous results are still shown. ", function () { self.renderPage(normalized, null, options); });
      }).finally(function () {
        clearTimeout(timeout);
        if (request === sequence) {
          var current = document.querySelector('[data-smk-stock-grid]');
          if (current) current.removeAttribute('aria-busy');
        }
      });
    };
    window.addEventListener('popstate', function () {
      var current = document.querySelector('sht-coll-prd-fltr-frm');
      if (current) current.renderPage(location.search.slice(1), null, {replaceHistory: true});
    });
    var current = new URLSearchParams(location.search);
    if (current.get(key) !== '1' || !current.get('sort_by')) {
      // Changing the default filter/order must start from the first filtered page.
      current.delete('page'); form.renderPage(current.toString(), null, {replaceHistory: true});
    }
  }).catch(function (error) { console.error('[stock-policy]', error); });
})();
